import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { logAction } from './actions'

function mapDispatchToState(dispatch) {
    return bindActionCreators({ logAction }, dispatch)
}

export default (InnerComponent) => {
    @connect(null, mapDispatchToState)
    class hocLoader extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return hocLoader
}
